// extracted by mini-css-extract-plugin
export default {"faq-page":"FAQPage_faq-page__NRCoa","faq-header-section":"FAQPage_faq-header-section__naQxJ","faq-content-section":"FAQPage_faq-content-section__eSsHv"};